import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Combination } from '@shared/interfaces/combination/combination.interface';
import {
  CombinationFilter,
  CombinationFilterValues
} from '@shared/interfaces/combination/combination-filters/combination-filters.interface';
import { Page } from '@shared/interfaces/pagination/page.interface';
import { Paging } from '@shared/interfaces/pagination/paging.interface';

export const userCombinations = createActionGroup({
  source: '[ USER COMBINATIONS ]',
  events: {
    'load table data and filters': props<{ options: CombinationFilter; paging: Paging }>(),
    'load table and data filters success': props<{
      page: Page<Combination>;
      filters: CombinationFilterValues;
    }>(),
    'clean up table data': emptyProps
  }
});
